export const agenciesConstants = {
  SET_AGENCIES_SUCCESS: 'SET_AGENCIES_SUCCESS',
  SET_AGENCIES_FAILURE: 'SET_AGENCIES_FAILURE',

  SET_WM_AGENCIES_SUCCESS: 'SET_WM_AGENCIES_SUCCESS',
  SET_WM_AGENCIES_FAILURE: 'SET_WM_AGENCIES_FAILURE',

  SET_PAYMENTS_LOG_SUCCESS: 'SET_PAYMENTS_LOG_SUCCESS',
  SET_PAYMENTS_LOG_FAILURE: 'SET_PAYMENTS_LOG_FAILURE',

  SET_AGENCY_STATUS: 'SET_AGENCY_STATUS',

  SET_AGENCY_PROMOCODE: 'SET_AGENCY_PROMOCODE',

  SET_REDIRECT_TO_AGENCIES_DATA: "SET_REDIRECT_TO_AGENCIES_DATA",
  CLEAR_REDIRECT_TO_AGENCIES_DATA: "CLEAR_REDIRECT_TO_AGENCIES_DATA",
};
